import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/grand-junction-digital-marketing")({
  head: () => cityDigitalMarketingHead("Grand Junction", "grand-junction"),
  component: () => (
    <CityDigitalMarketingPage
      city="Grand Junction"
      slug="grand-junction"
      intro="Grand Junction and the Western Slope are growing fast — but most Front Range agencies ignore them. We don't. We build digital marketing that reaches Western Slope customers wherever they search."
      whyUs={[
        "We serve the full state — Front Range to Western Slope, no extra charge",
        "GEO AI means Grand Junction businesses show up in AI search, not just Google",
        "Same owner-led quality we deliver in Colorado Springs, delivered to you",
      ]}
      nearby={[
        { name: "Pueblo", to: "/pueblo-digital-marketing" },
        { name: "Colorado Springs", to: "/colorado-springs" },
        { name: "Denver", to: "/denver-digital-marketing" },
        { name: "Boulder", to: "/boulder-digital-marketing" },
        { name: "Fort Collins", to: "/fort-collins-digital-marketing" },
      ]}
      testimonial={{
        quote:
          "We went from page 4 to the top of the Map Pack in under 5 months. They truly understand the Colorado market.",
        role: "Plumbing Company Owner",
        city: "Monument, CO",
      }}
      industryLinks={industryLinksFor("Grand Junction")}
    />
  ),
});
